/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-15 18:25 VN — WEB-20261015-suzitee-customall-fix
   Đã làm: khi Customall mở popup Preview (body.vm--block-scroll) thì khoá cuộn nền (html.sz-lock + body fixed top:-scrollY), đóng thì trả đúng vị trí cuộn.
   Observer chỉ attributes class trên body, chạy qua rAF, chỉ đổi khi state đổi; code ghi inline style/html class nên không tự kích lại. */
(function () {
  'use strict';
  try {
    var body = document.body, html = document.documentElement, locked = false, y = 0, scheduled = 0;
    function run() {
      scheduled = 0;
      var want = body.classList.contains('vm--block-scroll');
      if (want === locked) return;
      if (want) {
        y = window.pageYOffset || html.scrollTop || 0;
        body.style.position = 'fixed';
        body.style.top = -y + 'px';
        body.style.left = '0';
        body.style.right = '0';
        body.style.width = '100%';
        html.classList.add('sz-lock');
      } else {
        html.classList.remove('sz-lock');
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.right = '';
        body.style.width = '';
        window.scrollTo(0, y);
      }
      locked = want;
    }
    function schedule() { if (!scheduled) scheduled = requestAnimationFrame(run); }
    new MutationObserver(schedule).observe(body, { attributes: true, attributeFilter: ['class'] });
    schedule();
  } catch (e) {}
})();
